module.exports = __webpack_public_path__ + "icon-faq.svg?460336ec73f269e6cf661901fcc6c4b1";